import Ajax from "Utils/ajax";
export const calenderList = (data) => Ajax.post('hr/calenderList',data); 